import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useSystemVersion } from './queries';

/**
 * Die Build-Nummer unten in der Navigation, mittig unter dem Handbuch.
 *
 * Ein Link und keine Beschriftung: Wer wissen will, welcher Stand laeuft,
 * will meist auch wissen, was darin steckt und ob der Server in Ordnung
 * ist -- beides steht auf der Statusseite dahinter.
 *
 * Ohne ``system.read`` erscheint nichts. Solange die Nummer nicht da ist,
 * auch nicht -- ein Platzhalter, der kurz aufblitzt und dann ersetzt wird,
 * zieht den Blick an eine Stelle, an der nichts zu tun ist.
 */
export function VersionLink({ permissions }: { permissions: readonly string[] }) {
  const { t, i18n } = useTranslation();
  const allowed = permissions.includes('system.read');
  const version = useSystemVersion(allowed);

  if (!allowed || !version.data) return null;

  const { build, commit, committed_at: committedAt } = version.data;
  const label =
    build !== null
      ? t('system.build', { build })
      : t('system.versionFallback', { version: version.data.version });
  const title = [
    commit,
    committedAt ? new Date(committedAt).toLocaleString(i18n.language) : null,
    t('system.openStatus'),
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <Link to="/app/status" className="nav__version" title={title}>
      {label}
    </Link>
  );
}
